
export const UrlHelpers = {
    getSafeUrl: (url, fallbackUrl) => {
        try {
            const safeUrl = new URL(url, `${process.env.REACT_APP_UCAUTH_BASE_PROTO}${process.env.REACT_APP_UCAUTH_BASE_HOST}`);

            if (safeUrl.protocol.toLowerCase() !== "https:") {
                url = fallbackUrl;
            }
        } catch {
            url = fallbackUrl;
        }

        return url;
    }
}

export const RegexHelpers = {
    getPhoneRegex: () => {
        const phoneRegex = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

        return phoneRegex;
    }
}